import React from "react";

export default function MountsSummary() {
  return (
    <>
      <div className="py-2">
        <ul className="pl-6 app-list">
          <li>
            Developed backend systems for ERP solutions using{" "}
            <i>Laravel and MySQL</i>.
          </li>
          <li>
            Built a delivery location tracking feature by integrating{" "}
            <i>Firebase and Google Maps APIs</i>.
          </li>
          <li>
            Implemented video chat functionality using{" "}
            <i>JavaScript and open source libraries</i>.
          </li>
          <li>
            Designed database schemas and REST APIs supporting{" "}
            <i>web, Android, and iOS</i> platforms.
          </li>
        </ul>
      </div>
    </>
  );
}
